import { INVALID_HANDLEBAR_PATH_SEGMENT } from '../constants';

export const formatField = (rawField: string) =>
  rawField
    .split('.')
    .map((segment) => (INVALID_HANDLEBAR_PATH_SEGMENT.test(segment) ? `[${segment}]` : segment))
    .join('.');
